import { Button, InputLabel, Tooltip } from "@material-ui/core";
import { buttonsStyle } from "./tables/table";
import { Delete, Visibility, PictureAsPdf } from "@material-ui/icons";
import PreviewDialog from "./dialogs/PreviewDialog";
import { SERVER_URL } from "../../api";
import { uploadManualTeaser, deleteManualTeaser } from "../../api/project";
import { alertError, alertSuccess } from "../../utils/logger";
import { useState } from "react";

function UploadManualTeaser({ projectId, project, setProject }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [openPreviewDialog, setOpenPreviewDialog] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSelectedFile(file);
        setIsUploading(true);

        try {
            const response = await uploadManualTeaser(projectId, file);
            setProject(response.data);
            alertSuccess({ title: "Success", customMessage: "Manual teaser uploaded successfully." });
            setSelectedFile(null);
        } catch (error) {
            alertError({ error, customMessage: "Error uploading manual teaser." });
            setSelectedFile(null);
        } finally {
            setIsUploading(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete the manual teaser?")) {
            return;
        }

        try {
            const response = await deleteManualTeaser(projectId);
            setProject(response.data);
            alertSuccess({ title: "Success", customMessage: "Manual teaser deleted successfully." });
        } catch (error) {
            alertError({ error, customMessage: "Error deleting manual teaser." });
        }
    };

    const hasManualTeaser = project?.manualTeaser && project.manualTeaser !== "";

    return (
        <div className="mt-2">
            <InputLabel>Manual Teaser (PDF, Word, etc.)</InputLabel>
            <p style={{ fontSize: "12px", color: "#666", marginTop: "4px", marginBottom: "8px" }}>
                If a manual teaser is uploaded, it will be used instead of the auto-generated teaser in the frontend.
            </p>
            <label htmlFor="upload-manual-teaser" className="ml-0 mb-4 mt-1">
                <input
                    style={{ display: "none" }}
                    id="upload-manual-teaser"
                    name="upload-manual-teaser"
                    type="file"
                    accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={handleFileChange}
                    disabled={isUploading}
                />
                <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                    disabled={isUploading}
                >
                    {isUploading ? "Uploading..." : (selectedFile || hasManualTeaser ? "Change teaser" : "Upload teaser")}
                </Button>
            </label>
            {(selectedFile || hasManualTeaser) && (
                <>
                    <Tooltip title="Preview">
                        <Button
                            size="small"
                            onClick={() => setOpenPreviewDialog(true)}
                            style={{
                                ...buttonsStyle,
                                marginRight: "15px",
                            }}
                        >
                            <Visibility />
                        </Button>
                    </Tooltip>
                    <PreviewDialog
                        title="Preview Manual Teaser"
                        open={openPreviewDialog}
                        setOpen={setOpenPreviewDialog}
                        file={selectedFile}
                        src={
                            selectedFile
                                ? URL.createObjectURL(selectedFile)
                                : `${SERVER_URL}/${project.manualTeaser}`
                        }
                    />
                    <Tooltip title="Delete">
                        <Button
                            size="small"
                            onClick={handleDelete}
                            disabled={isUploading}
                        >
                            <Delete />
                        </Button>
                    </Tooltip>
                    {hasManualTeaser && (
                        <div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                            <PictureAsPdf style={{ color: "#666" }} />
                            <span style={{ fontSize: "12px", color: "#666" }}>
                                {project.manualTeaser.split('/').pop()}
                            </span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default UploadManualTeaser;

